/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React, { Fragment } from 'react'

import { EuiHorizontalRule } from '@elastic/eui'

import DeploymentTrafficFilterRulesets from '../DeploymentTrafficFilterRulesets'

import type { FunctionComponent } from 'react'

type Props = {
  regionId: string
  deploymentId: string
  trafficFilteringEnabled: boolean
  spacerBefore: boolean
}

const DeploymentTrafficFilterSection: FunctionComponent<Props> = ({
  regionId,
  trafficFilteringEnabled,
  spacerBefore,
}) => {
  if (trafficFilteringEnabled) {
    return (
      <Fragment>
        {spacerBefore && <EuiHorizontalRule />}

        <DeploymentTrafficFilterRulesets regionId={regionId} />
      </Fragment>
    )
  }

  return null
}

export default DeploymentTrafficFilterSection
